import { render, staticRenderFns } from "./TaskCompletion.vue?vue&type=template&id=f5a73a84&scoped=true&"
import script from "./TaskCompletion.vue?vue&type=script&lang=js&"
export * from "./TaskCompletion.vue?vue&type=script&lang=js&"
import style0 from "./TaskCompletion.vue?vue&type=style&index=0&id=f5a73a84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a73a84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VOverlay,VProgressCircular,VTextField})
